export default "__VITE_ASSET__ClscdvN5__"